// Resume Templates Configuration
// Based on provided template files

export interface ResumeTemplate {
  id: string;
  name: string;
  description: string;
  previewImage: string;
  category: 'professional' | 'ats' | 'executive' | 'original';
}

export const resumeTemplates: ResumeTemplate[] = [
  {
    id: 'professional-classic',
    name: 'Professional Classic',
    description: 'Traditional layout with centered header. Ideal for experienced professionals.',
    previewImage: '/templates/professional-classic.png',
    category: 'professional',
  },
  {
    id: 'ats-optimized',
    name: 'ATS Optimized',
    description: 'Clean, scannable format optimized for applicant tracking systems.',
    previewImage: '/templates/ats-optimized.png',
    category: 'ats',
  },
  {
    id: 'executive',
    name: 'Executive',
    description: 'Comprehensive format for senior professionals with objective section.',
    previewImage: '/templates/executive.png',
    category: 'executive',
  },
];

// Template for "Keep Original" option (only shown for uploaded resumes)
export const keepOriginalTemplate: ResumeTemplate = {
  id: 'keep-original',
  name: 'Keep Original Style',
  description: 'Maintain your uploaded resume structure with enhanced content.',
  previewImage: '/templates/keep-original.png',
  category: 'original',
};

export function getTemplateById(id: string): ResumeTemplate | undefined {
  if (id === 'keep-original') return keepOriginalTemplate;
  return resumeTemplates.find(t => t.id === id);
}

export function getAllTemplates(includeOriginal: boolean = false): ResumeTemplate[] {
  if (includeOriginal) {
    return [keepOriginalTemplate, ...resumeTemplates];
  }
  return resumeTemplates;
}
